import { createApp } from '@wu/widget-core';
import { meta } from './constants';
import { CountdownTimer } from './countdown-timer';

const { appAlias: alias, appName: name } = meta;

export default createApp({ alias, name }, CountdownTimer);
